import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Info, Plus, X } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

interface Props {
  loadingSendInfo: boolean;
  loadingReject: boolean;
  setOpenInfoModal: Dispatch<SetStateAction<boolean>>;
  setOpenRejectModal: Dispatch<SetStateAction<boolean>>;
  handleCreateOrder: () => void;
  showCreateOrder: boolean;
  showNeedsInfo: boolean;
  showReject: boolean;
}

export const FuelSlotRequestActions = ({
  loadingSendInfo,
  loadingReject,
  setOpenInfoModal,
  setOpenRejectModal,
  handleCreateOrder,
  showCreateOrder,
  showNeedsInfo,
  showReject,
}: Props) => {
  return (
    <Flex gap="12px">
      {showCreateOrder && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.GREEN_PRIMARY}
          onClick={handleCreateOrder}
        >
          <Plus />
          <Text fontWeight={600} fontSize="14px">
            Crear pedido
          </Text>
        </Button>
      )}
      {showNeedsInfo && (
        <Button
          paddingX="12px"
          height="32px"
          onClick={() => setOpenInfoModal(true)}
          disabled={loadingSendInfo || loadingReject}
        >
          <Info />
          <Text fontWeight={600} fontSize="14px">
            Requerir información
          </Text>
        </Button>
      )}
      {showReject && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.RED_ICON}
          onClick={() => setOpenRejectModal(true)}
          disabled={loadingSendInfo || loadingReject}
        >
          <X />
          <Text fontWeight={600} fontSize="14px">
            Rechazar
          </Text>
        </Button>
      )}
    </Flex>
  );
};
